import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PerformanceIndicatorsNotificationComponent } from "@modules/uk-finprom/components/performance-indicators-notification/performance-indicators-notification.component";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { UkRiskSummaryComponent } from "./components/uk-risk-summary/uk-risk-summary.component";
import { CustomerSegmentationModule } from "@modules/uk-finprom/components/customer-segmentation/customer-segmentation.module";

const components = [UkRiskSummaryComponent, PerformanceIndicatorsNotificationComponent];
const pipes = [TranslationPipeModule];

@NgModule({
	imports: [CommonModule, CustomerSegmentationModule, ...pipes],
	declarations: [...components],
	exports: [...components]
})
export class UKFinPromModule {}
